import { useState, useEffect } from 'react';
import { getBreedMatches, formatBreedInfo } from '../services/petMatchingService';

/**
 * Custom hook for managing breed recommendations
 * Fetches breed matches based on user preferences
 */
export const useBreedMatches = (userPreferences, limit = 5) => {
  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMatches = async () => {
      // Don't fetch if no preferences
      if (!userPreferences || Object.keys(userPreferences).length === 0) {
        setMatches([]);
        setLoading(false);
        return;
      }

      setLoading(true);
      setError(null);
      
      try {
        const breedMatches = await getBreedMatches(userPreferences, limit);
        const formattedMatches = breedMatches.map(formatBreedInfo);
        setMatches(formattedMatches);
      } catch {
        setError('Failed to fetch breed recommendations. Please try again later.');
        setMatches([]);
      } finally {
        setLoading(false);
      }
    };

    fetchMatches();
  }, [userPreferences, limit]);

  const refetch = async () => {
    if (!userPreferences || Object.keys(userPreferences).length === 0) return;
    
    setLoading(true);
    setError(null);
    
    try {
      const breedMatches = await getBreedMatches(userPreferences, limit);
      const formattedMatches = breedMatches.map(formatBreedInfo);
      setMatches(formattedMatches);
    } catch {
      setError('Failed to fetch breed recommendations. Please try again later.');
      setMatches([]);
    } finally {
      setLoading(false);
    }
  };

  return {
    matches,
    loading,
    error,
    refetch
  };
};